import { version } from 'Root/package.json';
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('jquery-validation/dist/jquery.validate');
require('eonasdan-bootstrap-datetimepicker');
window.toastr = require('toastr');
window.axios = require('axios');

const loggerEvent = {
  AddinName: 'moweco-laravel-frontend',
  Name: 'moweco-laravel-frontend',
  Version: version,
  Database: process.env.MIX_DATABASE_ID
}

window.loggerEvent = loggerEvent
// window.logger = window.fpcLibraries.logger.V4

require('./components/menu-top')